import {
  ModalV2,
  ChakraFlex,
  Text,
  FireflyButton,
  FAIconName,
} from '@equip.health/ui';
import { DischargePlanEvents } from '~/analytics/dischargePlanEvents';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

interface DiscardChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DiscardChangesModal = ({
  isOpen,
  onClose,
  onConfirm,
}: DiscardChangesModalProps) => {
  const { trackEvent } = useAnalytics();

  return (
    <ModalV2
      footerContent={
        <ChakraFlex
          alignItems="center"
          justifyContent="space-between"
          marginTop="24px"
          width="100%"
        >
          <FireflyButton
            id="close-discard-changes"
            leftIcon={FAIconName.arrowLeftRegular}
            onClick={() => {
              trackEvent(
                DischargePlanEvents.clickOnCancelButtonInDiscardUnsavedChangesModal,
              );
              onClose();
            }}
            variant="secondary"
          >
            Back to editing
          </FireflyButton>
          <FireflyButton
            id="discard-changes"
            leftIcon={FAIconName.trashRegular}
            onClick={() => {
              trackEvent(
                DischargePlanEvents.clickOnDiscardChangesButtonInDiscardUnsavedChangesModal,
              );
              onConfirm();
            }}
            variant="accent.critical"
          >
            Discard changes
          </FireflyButton>
        </ChakraFlex>
      }
      isOpen={isOpen}
      onClose={() => {
        trackEvent(
          DischargePlanEvents.clickOnXIconInDiscardUnsavedChangesModal,
        );
        onClose();
      }}
      title="Discard unsaved changes?"
    >
      <Text>You've made changes to this section that won't be saved.</Text>
    </ModalV2>
  );
};

export default DiscardChangesModal;
